
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRedux } from "redux/useRedux";
import Cookies from "universal-cookie";
export const AuthContext = React.createContext(null);
export const AuthProvider = ({ children }) => {
  const cookies = new Cookies();
  const [access_token, setAccessToken] = React.useState(cookies.get('access_token'));
  const [refreshToken, setRefreshToken] = React.useState(cookies.get('refreshToken'));
  const [expireTime, setExpireTime] = React.useState(cookies.get('expireTime'));
  const [role, setRole] = React.useState(cookies.get('role'));
  const [user, setUser] = React.useState(cookies.get('user'));
  const [agent_info, setAgent_info] = React.useState(cookies.get('agent_info'));
  const [login, setLogin] = React.useState(cookies.get('login'));
  const { dispatch, publicState } = useRedux()
  // const navigate = useNavigate()



  const updateUser = (res) => {
    cookies.set('user', JSON.stringify(res.user))
    setUser(res.user)
   
  }
  const updateContext = (res) => {
    cookies.set('access_token', res.access_token)
    cookies.set('refreshToken', res.refreshToken)
    cookies.set('expireTime', res.expireTime.toString())
    cookies.set('role', JSON.stringify(res.role))
    cookies.set('user', JSON.stringify(res.user))
    cookies.set('agent_info', JSON.stringify(res?.agent_info))
    setAccessToken(res.access_token)
    setRefreshToken(res.refreshToken)
    setExpireTime(res.expireTime.toString())
    setRole(res.role)
    setUser(res.user)
    setAgent_info(res?.agent_info)
    handlePreLogin(res)
    // for backend
    cookies.set('jwtToken', res.access_token, { domain: 'investo.ir', })
  };


  const handlePreLogin = (res) => {
    cookies.set('login', "1")
    setLogin("1")
    setTimeout(() => {
      console.log(publicState?.product_id);
      if (publicState?.product_id) {
        window.location = `/basket?product_id=${publicState?.product_id}`
      }else{

        window.location = "/dashboard"
      }
      // else if (res?.user?.risk_points)
      // else {
      //   window.location = "/risk"
      // }
    }, 500);
  };

  const handleLogout = () => {
    // logout({})
    //   .then((res) => {
    cookies.remove("access_token");
    cookies.remove("refreshToken");
    cookies.remove("expireTime");
    cookies.remove("role");
    cookies.remove("user");
    cookies.remove("userPermission");
    cookies.remove("agent_info");
    setAccessToken(null)
    setRefreshToken(null)
    setExpireTime(null)
    setRole(null)
    setUser(null)
    setAgent_info(null)

    cookies.remove('login')
    setLogin("0")

    window.location = "/"
    // })
    // .catch((err) => {
    //   // snackbar?.showFailure("مشکلی پیش امده");
    // });
  };

  const updateToken = (res) => {
    cookies.set('access_token', res.accessToken)
    cookies.set('refreshToken', res.refreshToken)
    cookies.set('expireTime', res.expireTime.toString())
    setAccessToken(res.access_token)
    setRefreshToken(res.refreshToken)
    setExpireTime(res.expireTime.toString())
    window.reload();
    // for backend
    cookies.set('jwtToken', res.access_token, { domain: 'investo.ir', })
  }
  const updateRisk = (res) => {
    let newUser = { ...user }
    newUser.risk_points = res.risk_points ?? 0
    newUser.net_range = res.net_range ?? 0
    newUser.risk_range = res.risk_range ?? 0
    cookies.set('user', newUser)
    setUser(newUser)


  }


  const value = {
    access_token,
    refreshToken,
    role,
    user,
    agent_info,
    login,

    handlePreLogin: handlePreLogin,

    handleLogout: handleLogout,
    updateRisk: updateRisk,
    updateUser: updateUser,
    updateContext: updateContext,
    updateToken: updateToken,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
